import { useEffect, useState } from 'react'

export const useScrollEvents = (elementRef, callback, scrollType = 'top') => {

    const [isFetching, setIsFetching] = useState(false);
    const [isScrolledToTheEnd, setIsScrolledToTheEnd] = useState(false)

    const scrollToBottom = () => {
        let messageList = elementRef.current
        if (messageList) {
            let scrollHeight = messageList.scrollHeight;
            let height = messageList.clientHeight;
            let maxScrollTop = scrollHeight - height;
            messageList.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }
    }

    function getOffset(element) {
        if (!element || !element.getClientRects().length) {
            return { top: 0, left: 0 };
        }

        let rect = element.getBoundingClientRect();
        let win = element.ownerDocument.defaultView;
        return (
            {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            });
    }

    useEffect(() => {
        if (elementRef.current) {
            elementRef.current.addEventListener('scroll', handleScroll);
        }
        return () => elementRef?.current?.removeEventListener('scroll', handleScroll);
    }, [Boolean(elementRef.current)]);

    useEffect(() => {
        if (isFetching) {
            callback()
            setIsFetching(false)
        }
    }, [isFetching]);

    function handleScroll() {
        let scrolledToTheMax

        let scrollTop = elementRef.current.scrollTop
        let scrollHeight = elementRef.current.scrollHeight
        let offsetHeight = elementRef.current.offsetHeight
        let isAtBottom = (scrollHeight - scrollTop - offsetHeight) < 5

        // useful for knowing whether or not to scroll to the bottom
        setIsScrolledToTheEnd(isAtBottom)

        // check our top/bottom to see if we need to fetch things
        if (scrollType === 'bottom') {
            scrolledToTheMax = isAtBottom
        } else {
            scrolledToTheMax = scrollTop === 0
        }
        
        if (!scrolledToTheMax || isFetching) return;

        setIsFetching(true);
    }

    return [isScrolledToTheEnd, scrollToBottom, getOffset];
}